/* Mystery-Packs LP — ES5, kein jQuery. Sticky-Kaufleiste + Lead-Event. */
(function () {
  'use strict';
  /* Sticky-Bar: sichtbar, sobald der Hero aus dem Viewport gescrollt ist,
     unsichtbar sobald die Preisleiter (#preise) im Viewport ist.
     Solange die Bar sichtbar ist, bekommt <body> ein padding-bottom in Barhoehe —
     sonst verdeckt die fixierte Leiste auf Mobil die letzte Kaufzeile. */
  var bar = document.getElementById('lvm-sticky');
  var hero = document.getElementById('lvm-hero');
  var tiers = document.getElementById('preise');
  var ticking = false;
  var padded = false;

  function apply() {
    ticking = false;
    if (!bar || !hero || !tiers) { return; }
    var heroGone = hero.getBoundingClientRect().bottom < 0;
    var t = tiers.getBoundingClientRect();
    var tiersVisible = t.top < window.innerHeight && t.bottom > 0;
    var on = heroGone && !tiersVisible;
    bar.className = on ? 'lvm-sticky is-on' : 'lvm-sticky';
    /* offsetHeight ist 0, sobald die Bar display:none ist (Desktop-Breakpoint) —
       damit raeumt sich das padding beim Drehen/Resizen von selbst wieder auf. */
    var h = on ? bar.offsetHeight : 0;
    if (h > 0) {
      document.body.style.paddingBottom = h + 'px';
      padded = true;
    } else if (padded) {
      document.body.style.paddingBottom = '';
      padded = false;
    }
  }

  /* Scroll-/Resize-Rechnung auf einen Frame pro Tick drosseln. */
  function request() {
    if (ticking) { return; }
    ticking = true;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(apply);
    } else {
      apply();
    }
  }

  if (bar) {
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
    window.addEventListener('orientationchange', request, { passive: true });
    request();
  }

  /* generate_lead beim Absenden des Palette/Abo-Formulars (data-lvm-lead) */
  var leadForms = document.querySelectorAll('form[data-lvm-lead]');
  for (var i = 0; i < leadForms.length; i++) {
    leadForms[i].addEventListener('submit', function () {
      try {
        if (window.gtag) { window.gtag('event', 'generate_lead', { form: 'mystery-grossmenge' }); }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'generate_lead', form: 'mystery-grossmenge' });
      } catch (e) { /* Tracking darf das Absenden nie blockieren */ }
    });
  }
})();
